import { useTranslation } from "react-i18next";
import FormField from "../../components/ui/FormField";
import TextAreaField from "../../components/ui/TextAreaField";
import MediaSelectorButton from "../../components/media/MediaSelectorButton";
import VariableInsertDropdown from "./VariableInsertDropdown";
import { FIELD_TYPES } from "./emailTemplateFieldsConfig";

function FieldLabelRow({
  label,
  required,
  variables,
  onInsert,
  showInsert,
  showRestore,
  onRestore,
}) {
  const { t } = useTranslation();
  return (
    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2">
      <label className="form-label mb-0">
        {t(label)}
        {required && <span className="text-danger ms-1">*</span>}
      </label>
      <div className="d-flex align-items-center gap-1">
        {showRestore && (
          <button
            type="button"
            className="btn btn-sm btn-outline-secondary"
            onClick={onRestore}
            title={t("Restore default for this field")}
          >
            <i className="bi bi-arrow-counterclockwise me-1" />
            {t("Restore")}
          </button>
        )}
        {showInsert && (
          <VariableInsertDropdown variables={variables} onInsert={onInsert} />
        )}
      </div>
    </div>
  );
}

export default function EmailTemplateField({
  field,
  register,
  errors,
  watch,
  setValue,
  mediaDefault,
  onRestoreField,
  hasDefault,
}) {
  const { t } = useTranslation();
  const { label, name, type, required, description, variables } = field;
  const currentValue = watch?.(name) ?? "";

  const insertVariable = (variableKey) => {
    const nextValue = `${currentValue || ""}${variableKey}`;
    setValue(name, nextValue, { shouldDirty: true });
  };

  const handleRestoreField = () => {
    onRestoreField?.(name, label);
  };

  return (
    <div
      className={`mb-3 ${type === FIELD_TYPES.RICHTEXT || type === FIELD_TYPES.MEDIA ? "col-12" : "col-md-6"}`}
    >
      {type !== FIELD_TYPES.MEDIA && (
        <FieldLabelRow
          label={label}
          required={required}
          variables={variables}
          onInsert={insertVariable}
          showInsert
          showRestore={hasDefault}
          onRestore={handleRestoreField}
        />
      )}

      {type === FIELD_TYPES.RICHTEXT && (
        <TextAreaField
          name={name}
          register={register}
          required={required}
          errors={errors}
          isRichTextEditor
          watch={watch}
          setValue={setValue}
        />
      )}

      {type === FIELD_TYPES.MEDIA && (
        <MediaSelectorButton
          label={t(label)}
          inputName={name}
          mediaType="image"
          register={register}
          errors={errors}
          onChange={(value) => setValue(name, value, { shouldDirty: true })}
          defaultSelected={mediaDefault || []}
        />
      )}

      {(type === FIELD_TYPES.TEXT || type === FIELD_TYPES.EMAIL) && (
        <FormField
          name={name}
          type={type === FIELD_TYPES.EMAIL ? "email" : "text"}
          register={register}
          required={required}
          errors={errors}
        />
      )}

      {description && (
        <small className="text-muted d-block mt-1">
          <i className="bi bi-info-circle me-1" />
          {t(description)}
        </small>
      )}
    </div>
  );
}
